module.exports = __webpack_public_path__ + "img/workbooks.12424854.png";